module.exports = __webpack_public_path__ + "media/images/mobile/city_img/g1-aaf01666c4442d5448563f6f8db11cfb.jpg";